import React from 'react';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import * as S from './Scrollbar.styled';
export const Scrollbar = ({ maxHeight, children }) => {
    return (React.createElement(S.Container, null,
        React.createElement(SimpleBar, { style: { maxHeight } }, children)));
};
